/// <reference path="DOMAttached.js" />

class TextBox extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.defaultButton = document.getElementById(options.defaultButtonId);

		if (this.defaultButton != null) {
			this.safeObserve(this.el.querySelector('input'), 'keypress', this.onKeyPress.bind(this));
		}

		if (this.options.CapsLockWarningID != null) {
			this.safeObserve(this.el.querySelector('input'), 'keypress', this.onKeyup2.bind(this));
			this.warningLabel = document.getElementById("contentcontent_" + this.options.CapsLockWarningID);
		}

		if (this.options.TextBoxMode == "SingleLine") {
			this.fadeInterval = 100;
			this.safeObserve(this.el.querySelector('input'), 'focus', this.onFocus.bind(this));
			this.safeObserve(this.el.querySelector('input'), 'blur', this.onBlur.bind(this));
			this.safeObserve(this.el.querySelector('input'), 'keyup', this.onChange.bind(this));
		} else if (this.options.TextBoxMode == "MultiLine") {
			this.makeTextareaAutoResize();
			if (this.options.MaxLength > 0) {
				this.safeObserve(this.el.querySelector('textarea'), 'keyup', this.onKeyup.bind(this));
			}
			this.previous = this.el.querySelector('textarea').value;

			if (this.options.RemainingCharactersControl != null) {
				this.counter = document.getElementById(this.options.RemainingCharactersControl);
				this.counter.innerHTML = this.options.RemainingCharactersTR.replace("{charactersleft}", this.options.MaxLength - this.el.querySelector('textarea').value.length);
			}
		}

		if (this.options.isFocused) {
			this.el.querySelector('input').focus();
		}

		if (this.options.showPasswordControlId) {
			this.isPasswordShownAsText = false;
			this.safeObserve(document.getElementById(this.options.showPasswordControlId), 'click', this.onShowPasswordClick.bind(this));
		}
	}

	// Use default button when hitting return key in this text box.
	// When shift key is down, nothing happens (-> user can still line-break in multi-line textboxes).
	onKeyPress(ev) {
		if (this.isEnterKeyPressed(ev) == true && !ev.shiftKey) {
			ev.preventDefault();
			ev.stopPropagation();
			// Just calling defaultButton.click() won't work in FF if the button is a link.
			this.defaultButton.dispatchEvent(new MouseEvent("click"));
		}
	}

	isEnterKeyPressed(ev) {
		return ev.keyCode == 13;
	}

	onFocus(ev) {
		this.el.classList.add('focused');
		if (this.options.passwordRulesId !== undefined
			&& this.el.querySelector('input').value.length < this.options.passwordMinimalLength) {
			jQuery("#" + this.options.passwordRulesId).fadeIn(this.fadeInterval);
		}
	}

	onBlur(ev) {
		this.el.classList.remove('focused');
	}

	onChange(ev) {
		if (this.options.passwordRulesId !== undefined) {
			if (this.el.querySelector('input').value.length < this.options.passwordMinimalLength) {
				jQuery("#" + this.options.passwordRulesId).fadeIn(this.fadeInterval);
			} else {
				jQuery("#" + this.options.passwordRulesId).fadeOut(this.fadeInterval);
			}
		}
	}

	// code from http://www.codeproject.com/Articles/17180/Detect-Caps-Lock-with-Javascript
	// check whether shift with small letter is smal letter 
	// or shift with big letter ist big letter -> caps lock activated
	// checks for caps lock
	onKeyup2(e) {
		kc = e.keyCode ? e.keyCode : e.which;
		sk = e.shiftKey ? e.shiftKey : ((kc == 16) ? true : false);
		if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk))
			this.warningLabel.style.visibility = 'visible';
		else
			this.warningLabel.style.visibility = 'hidden';

		var charKeyCode = e.keyCode ? e.keyCode : e.which; // To work with both MSIE & Netscape
		var shiftKey = e.shiftKey ? e.shiftKey : ((charKeyCode == 16) ? true : false);
	}

	onKeyup(ev) {

		if (this.el.querySelector('textarea').value.length > this.options.MaxLength) {
			this.el.querySelector('textarea').value = this.previous;
		} else {
			this.previous = this.el.querySelector('textarea').value;
			if (this.counter !== null && this.counter !== undefined) {
				this.counter.innerHTML = this.options.RemainingCharactersTR.replace("{charactersleft}", this.options.MaxLength - this.el.querySelector('textarea').value.length);
			}
		}
	}

	onShowPasswordClick() {
		if (this.isPasswordShownAsText) {
			this.el.querySelector('input').setAttribute("type", "password");
			document.getElementById(this.options.showPasswordControlId).innerHTML = this.options.showPasswordText;
		} else {
			this.el.querySelector('input').setAttribute("type", "text");
			document.getElementById(this.options.showPasswordControlId).innerHTML = this.options.hidePasswordText;
		}
		this.isPasswordShownAsText = !this.isPasswordShownAsText;
	}

	// https://stackoverflow.com/a/25621277
	makeTextareaAutoResize() {
		jQuery(this.el.querySelector('textarea')).each(function() {
			this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:scroll;");
		}).on("input", function() {
			this.style.height = "auto";
			this.style.height = (this.scrollHeight) + "px";
		});
	}
}
